import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../context/AuthContext";
import { forViewer, noticesQuery, viewerIdOf } from "../services/queries";

export const useNotices = (options?: { excludeFeedHidden?: boolean }) => {
  const { user, token } = useAuth();

  return useQuery({
    ...forViewer(noticesQuery(user?.schoolId, token, options), viewerIdOf(user)),
    enabled: !!user?.schoolId && !!token,
  });
};
